<template>
    <div class="public_container customer_add_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

            </ReturnNavBar>
        </div>
        <div class="mobile_container" v-loading="loading">
            <div id="qrcodeOutBox">
                <div class="customer-company-card-wrap" id="companyWatermark">
                    <img
                        src="https://download.hecoos.com/enlightv/2024-44/4d94ad87c1c609bf8fd415fdc6ac8c1e.png"
                        alt=""
                        crossorigin
                        class="company-logo"
                    />
                    <div class="company-info-card">
                        <div class="company-info-card-left">
                            <p>{{ customerName }}</p>
                            <p>
                                <span>由</span><span>{{ userName }}</span
                                ><span>分享</span><span>/</span><span>分享于{{ time }}</span>
                            </p>
                        </div>
                        <div class="company-info-card-right">
                            <img :src="companyLogo" alt="" />
                        </div>
                    </div>
                    <ul class="company-info-list" v-loading="loading">
                        <li class="company-info-item" v-for="info in companyInfoList" :key="info.field">
                            <p class="company-info-item-title">{{ info.title }}</p>
                            <div class="company-info-item-content">
                                <CustomFieldsDetailForm
                                    :details="customerDetail"
                                    :field_table="'customers'"
                                    :filter_system="false"
                                    :pk_id="customer_id"
                                    @loading-change="detailLoadingChange"
                                    :custom_form_class="'customer_share_detail_form'"
                                    :form_col_span="'24'"
                                    v-if="editDetailsShow"
                                ></CustomFieldsDetailForm>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="ellipsis_btn">
                    <van-icon name="ellipsis" />
                </div>
            </div>
            <div class="mobile_footer_link">
                <div class="mobile_footer_link_btns">
                    <van-button @click="handleClickCopyUrl">复制链接</van-button>
                    <van-button type="info" @click="handleClickCopyImg">下载公司卡片</van-button>
                </div>
                <p>复制链接或下载公司卡片分享给他人，打开链接或图片后可查看客户信息</p>
            </div>
        </div>
    </div>
</template>

<script>
import watermark from "watermark-dom";
import html2canvas from "html2canvas";
import { GetCustomerPublicDetail, GetCustomerPrivateDetail } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFieldsDetailForm from "@/components/pComponents/CustomFieldsDetailForm.vue";
export default {
    name: "MCustomerShareTpl",
    components: { ReturnNavBar, CustomFieldsDetailForm },
    data() {
        return {
            loading: false,
            type: this.$route.query && this.$route.query.type, // 1: 公海，2:私海
            customer_id: this.$route.query && this.$route.query.customer_id,
            customerName: this.$route.query && this.$route.query.cname,
            userName: this.$route.query && this.$route.query.name,
            phone: "",
            companyInfoList: [
                {
                    field: "info",
                    title: "客户信息",
                },
            ],
            companyLogo: "",
            customerDetail: {},
            editDetailsShow: true,
            time: "",
        };
    },
    created() {
        const phone =
            this.$store.state.userInfo && this.$store.state.userInfo.user && this.$store.state.userInfo.user.phone;
        this.phone = phone.substr(-4);
        this.getCustomerDetail();
        const date = new Date();
        const time =
            date.getFullYear() +
            "." +
            (date.getMonth() + 1).toString().padStart(2, "0") +
            "." +
            date.getDate().toString().padStart(2, "0");
        this.time = time;
        this.getCopyLink();
    },
    mounted() {
        // this.createWatermark();
    },
    methods: {
        detailLoadingChange(loading) {
            this.loading = loading;
        },
        getCustomerDetail() {
            if (this.type == 1) {
                GetCustomerPublicDetail(this.customer_id).then((res) => {
                    if (res.code === 200) {
                        this.customerDetail = JSON.parse(JSON.stringify(res.data));
                        this.editDetailsShow = false;
                        this.$nextTick(() => {
                            this.editDetailsShow = true;
                        });
                    }
                });
            } else {
                GetCustomerPrivateDetail(this.customer_id).then((res) => {
                    if (res.code === 200) {
                        this.customerDetail = JSON.parse(JSON.stringify(res.data));
                        this.editDetailsShow = false;
                        this.$nextTick(() => {
                            this.editDetailsShow = true;
                        });
                    }
                });
            }
        },
        async handleClickCopyImg() {
            let Dom = document.querySelector("#qrcodeOutBox");
            let DomChild = document.querySelector("#companyWatermark");
            let divElement = document.createElement("div");
            divElement.appendChild(DomChild);
            Dom.appendChild(divElement);
            // const canvas = await html2canvas(document.querySelector('#qrcodeOutBox'), { allowTaint: false, useCORS: true,height: document.scrollHeight,windowHeight: document.scrollHeight });
            const canvas = await html2canvas(divElement, {
                allowTaint: true,
                useCORS: true,
                height: document.scrollHeight,
                windowHeight: document.scrollHeight,
            });
            if (canvas) {
                const url = canvas.toDataURL("image/png").replace(/^data:image\/[^;]/, "data:application/octet-stream");
                var link = document.createElement("a");
                link.download = "公司卡片.png"; // 下载的文件名
                link.href = url;
                link.click();
                // Dom.removeChild(divElement);
            }
        },
        getCopyLink() {
            const domain = window.location.protocol + "//" + window.location.host;
            const textToCopy = `${domain}/#/customer/m_share?customer_id=${this.customer_id}&type=${this.type}&name=${this.userName}&phone=${this.phone}`;
            this.copyLink = textToCopy;
        },
        handleClickCopyUrl() {
            const textToCopy = this.copyLink;
            const textarea = document.createElement("textarea");
            textarea.value = textToCopy;
            document.body.appendChild(textarea);
            // 选中文本并复制
            textarea.select();
            document.execCommand("copy");
            // 移除临时元素
            document.body.removeChild(textarea);
            this.$toast({
                type: "success",
                message: "复制成功",
            });
        },
        createWatermark() {
            this.watermarkDom = {
                watermark_parent_node: "companyWatermark",
                watermark_txt: this.userName + this.phone,
                watermark_color: "gray",
                watermark_fontsize: "16px",
                watermark_cols: 6, // 水印列数
                watermark_x: 20, //水印起始位置x轴坐标
                watermark_y: 0, //水印起始位置Y轴坐标
                watermark_x_space: -10,
                watermark_angle: 45,
            };
            watermark.init(this.watermarkDom);
        },
        clearWatemark() {
            this.watermarkDom && watermark.remove(this.watermarkDom);
        },
    },
};
</script>

<style lang="scss" scoped>
.mobile_container {
    padding: 0 16px;
    background-color: #ffffff;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
#qrcodeOutBox {
    flex: 1;
    position: relative;
    .ellipsis_btn {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 22px;
        background-color: #ffffff;
        text-align: center;
        .van-icon {
            font-size: 22px;
        }
    }
}
.customer-company-card-wrap {
    width: 100%;
    padding: 16px 16px 32px;
    background: linear-gradient(134.48deg, rgba(255, 255, 255, 1) 0.16%, rgba(255, 255, 255, 1) 100%);
    position: relative;

    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 180px;
        background-image: url("data:image/png;base64,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");
        background-repeat: no-repeat;
        background-size: 100% auto;
    }

    .company-logo {
        width: 55px;
        margin-bottom: 20px;
    }

    .company-info-card {
        width: 100%;
        height: 78px;
        opacity: 1;
        border-radius: 8px;
        padding: 12px;
        display: flex;
        justify-content: space-between;
        position: relative;

        &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            // background:url("https://download.hecoos.com/enlightv/2024-45/3dc4196eb011664acd1bdd6596318d79.png") no-repeat;
            background: url("data:image/png;base64,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")
                no-repeat;
            background-size: 100% 100%;
            z-index: 1;
        }

        .company-info-card-left {
            p:nth-child(1) {
                font-size: 18px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 26.06px;
                color: rgba(51, 51, 51, 1);
            }

            p:nth-child(2) {
                margin-top: 3px;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(102, 102, 102, 1);
                display: flex;
                gap: 2px;
            }
        }

        .company-info-card-right {
            width: 48px;
            height: 48px;
            opacity: 1;
            border-radius: 6px;

            img {
                width: 48px;
                height: 48px;
                opacity: 1;
                border-radius: 6px;
                object-fit: cover;
            }
        }
    }

    .company-info-item {
        margin-top: 16px;

        .company-info-item-title {
            position: relative;
            font-size: 14px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 10px;
            padding-left: 12px;

            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                width: 4px;
                height: 22px;
                opacity: 1;
                border-radius: 20px;
                background: #2990ff;
            }
        }

        .company-info-item-content {
            padding: 12px;
            border-radius: 8px;
            // background: url("https://download.hecoos.com/enlightv/2024-45/ff41bb6532045eaee1ef757da3c7d474.png") no-repeat;
            background: url("data:image/png;base64,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")
                no-repeat;
            background-size: 100% 100%;

            & > div {
                margin-bottom: 12px;

                p:nth-child(1) {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(153, 153, 153, 1);
                }

                p:nth-child(2) {
                    margin-top: 2px;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }
            }
        }
    }
}
.mobile_footer_link {
    flex-shrink: 0;
    padding: 10px 0;
    .mobile_footer_link_btns {
        display: flex;
        gap: 10px;
        .van-button {
            flex: 1;
            height: 38px;
            font-size: 16px;
            border-radius: 8px;
            &:nth-child(1) {
                border-color: rgba(247, 248, 250, 1);
                background: rgba(247, 248, 250, 1);
            }
            &:nth-child(2) {
                border-color: rgba(41, 144, 240, 1);
                background: rgba(41, 144, 240, 1);
                color: rgba(255, 255, 255, 1);
            }
        }
    }
    & > p {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
        text-align: center;
    }
}
</style>
